import { GridColDef } from "@mui/x-data-grid-pro";
import { Button, IconButton } from "@mui/material";

import ItemStatus from "../../../../../../common/components/item_status";
import DynamicIcon from "../../../../../../common/components/dynamic_icon";

/**
 * GeneratePatrimonioCentroCustoColumnsDefinition
 */

type Props = {
  onActionEditar: (idPatrimonioCentroCusto: number | null, openState: boolean) => void;
  onActionDeletar: (idPatrimonioCentroCusto: number | null, openState: boolean) => void;
  // onActionCopiar: (idPatrimonioCentroCusto: number | null, openState: boolean) => void;
  onEnterChecklists: (idPatrimonioCentroCusto: number | null, newTabOpen: boolean) => void;
};

export const GeneratePatrimonioCentroCustoColumnsDefinition = ({
  onActionEditar,
  onActionDeletar,
  // onActionCopiar,
  onEnterChecklists,
}: Props): GridColDef[] => {

  const computeItemStatusTitle = (status: number) => {
    switch (status) {
      case 0:
        return "Em Andamento";
      case 1:
        return "Finalizado";
      default:
        return "?";
    }
  };

  const computeItemStatusColor = (status: number) => {
    switch (status) {
      case 0:
        return "gray";
      case 1:
        return "green";
      default:
        return "blue";
    }
  };

  const computeItemStatusDescription = (status: number) => {
    switch (status) {
      case 0:
        return "Em Andamento";
      case 1:
        return "Finalizado";
      default:
        return "?";
    }
  };

  return [
    {
      field: "status",
      filterable: false,
      headerName: "Status",
      minWidth: 120,
      width: 120,
      sortable: false,
      renderCell: (params) => (
        <div className="w-full h-full flex justify-center items-center">
          <ItemStatus
            size="autowidth"
            textSize="small"
            title={computeItemStatusTitle(params.value)}
            color={computeItemStatusColor(params.value)}
            description={computeItemStatusDescription(params.value)}
          />
        </div>
      )
    },
    {
      field: "nomeCentroCusto",
      filterable: false,
      headerName: "Centro de Custo",
      flex: 1,
      minWidth: 250,
      sortable: false,
      headerClassName: 'funcionarios-header',
    },
    // {
    //   field: "exportar",
    //   filterable: false,
    //   headerName: "Exportar",
    //   sortable: false,
    //   width: 110,
    //   minWidth: 110,
    //   valueGetter: (_, row) => { return row['idChecklistServico'] as number; },
    //   renderCell: ({ value }) => {
    //     return (
    //       <Button
    //         onMouseDown={(e) => {
    //           onActionExportar(value);
    //           e.preventDefault();
    //         }}
    //         sx={{
    //           fontSize: 11,
    //           paddingX: '.4rem',
    //           paddingY: 0,
    //           background: '#e6e6e6',
    //           borderLeft: '.2rem solid #35aa47',
    //           borderRadius: 0,
    //           color: 'black',
    //           fontWeight: 'normal',
    //         }}>
    //         Checklists
    //       </Button>
    //     );
    //   },
    // },
    {
      field: 'idPatrimonioCentroCusto',
      sortable: false,
      filterable: false,
      headerName: 'Ações',
      width: 100,
      resizable: false,
      renderCell: (params) => {
        return (
          <div className="flex items-center justify-center w-full h-full gap-2">
            <IconButton
              onMouseDown={e => { onActionEditar(params.value, true) }}>
              <DynamicIcon nameIcon="EditRounded" size={25} className="dark:text-white text-primary-green" />
            </IconButton>

            <IconButton onClick={() => { onActionDeletar(params.value, true) }}>
              <DynamicIcon nameIcon="DeleteForeverRounded" size={25} className="text-red-500" />
            </IconButton>
          </div>
        );
      }
    },
    {
      field: "itens",
      filterable: false,
      headerName: "Checklists",
      sortable: false,
      flex: 1,
      minWidth: 200,
      valueGetter: (_, row) => { return row['idPatrimonioCentroCusto'] as number; },
      renderCell: ({ value }) => {
        return (
          <Button
            onMouseDown={(e) => {
              if (e.button === 1) {
                onEnterChecklists(value, true);
              } else {
                onEnterChecklists(value, e.ctrlKey);
              }
              e.preventDefault();
            }}
            sx={{
              fontSize: 11,
              paddingX: '.4rem',
              paddingY: 0,
              background: '#e6e6e6',
              borderLeft: '.2rem solid #8e44ad',
              borderRadius: 0,
              color: 'black',
              fontWeight: 'normal',
            }}>
            Checklists
          </Button>
        );
      },
    },

    // {
    //   field: 'copiar',
    //   sortable: false,
    //   filterable: false,
    //   headerName: 'Copiar',
    //   width: 65,
    //   resizable: false,
    //   valueGetter: (_, row) => row['idChecklistServico'] as number,
    //   renderCell: (params) => {
    //     return (
    //       <div className="flex items-center justify-center w-full h-full gap-2">
    //         <IconButton onClick={() => { onActionCopiar(params.value, true) }}>
    //           <DynamicIcon nameIcon="ContentCopy" size={25} className="text-purple-500" />
    //         </IconButton>
    //       </div>
    //     );
    //   }
    // },
  ];
}